import React from 'react';
import { CornerDownRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Message from './Message';
import { ChatMessage as ChatMessageType } from 'store/chat.store';
import { cn } from 'lib/utils';
interface ChatMessagesProps {
    messages: ChatMessageType[];
    className?: string;
}
export const ChatMessages: React.FC<ChatMessagesProps> = React.memo(({ messages, className, }) => {
    const { t } = useTranslation();
    return (<div className={cn('space-y-2', className)}>
      {messages.map((message, index) => (<div key={message.id || `message-${index}`} className="space-y-2 mb-8">
          {/* Quote text if present */}
          {message.quoteText && (<div className="flex justify-end text-gray-500 dark:text-gray-400 pr-2 rounded-t-sm rounded">
              <div className="gap-2 flex max-w-xs w-full justify-end">
                <CornerDownRight className="flex-shrink-0 h-4 w-4"/>
                <span className="text-sm overflow-hidden overflow-ellipsis line-clamp-3">
                  {message.quoteText}
                </span>
              </div>
            </div>)}

          {/* Image URLs if present */}
          {message.imageUrls && message.imageUrls.length > 0 && (<div className="flex justify-end text-gray-500 dark:text-gray-400 rounded-t-sm rounded">
              <div className="flex gap-2 justify-end flex-wrap">
                {message.imageUrls.map((image, imgIndex) => (<img key={`img-${imgIndex}`} src={image} alt={t("chat_attachment")} className="w-16 h-16 cursor-pointer rounded-md object-cover"/>))}
              </div>
            </div>)}

          {/* Message content */}
          {message.content && (<Message key={`message-${message.id}`} id={message.id} type={message.role === 'assistant' ? 'ai' : 'user'} text={message.content}/>)}
        </div>))}
    </div>);
});
export default ChatMessages;
